import { render, staticRenderFns } from "./ManageChartsCalculation.vue?vue&type=template&id=01102013&"
import script from "./ManageChartsCalculation.vue?vue&type=script&lang=ts&"
export * from "./ManageChartsCalculation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports